import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<{ [key: string]: string }> {
    // Replace '-' with '_' in the language code if present because of lokalise format
    lang = lang.includes('-') ? lang.replace('-', '_') : lang;
    // Special case for translationKeys
    if (lang === 'translationKeys') {
      return this.http.get<{ [key: string]: string }>(
        '/assets/i18n/translationKeys.json'
      );
    }

    // Use URL in development from Angular's proxy
    const baseUrl = environment.localhost
      ? ''
      : `${environment.translationCacheServiceUrl}`;

    const url = `${baseUrl}/translations/download?projectId=${environment.lokaliseProjectId}&language=${lang}`;
    return this.http.get<{ [key: string]: string }>(url).pipe(
      catchError(() => {
        return this.http.get<{ [key: string]: string }>(
          '/assets/i18n/en_GB.json'
        );
      })
    );
  }
}
